'use strict';

function clearErrorOnField ($element) {
  var parent = $element.parent().removeClass('error has-error');

  return parent.prev('.error-msg').removeClass('visible');
}

module.exports = clearErrorOnField;
